<template>
  <div v-loading="loading">
    <el-form ref="from_params" :model="searchParams">
      <QS-search maxLine="1">
        <el-form-item label="方案ID" prop="id">
          <el-input
            v-number:integer
            v-model="searchParams.id"
            placeholder="请输入方案ID"
            clearable
          />
        </el-form-item>
        <el-form-item label="方案名称" prop="name">
          <el-input
            maxlength="50"
            v-model="searchParams.name"
            placeholder="请输入方案名称"
            clearable
          />
        </el-form-item>
        <CarBrandSeriesModel
          ref="carBrandSeriesModelRef"
          :showModel="true"
          v-model="searchParams.brandSeriesModel"></CarBrandSeriesModel>
        <el-form-item label="方案所属城市" prop="adcode">
          <el-select
            v-model="searchParams.adcode"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="item in cityList"
              :key="item.adcode"
              :label="item.city"
              :value="item.adcode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="方案状态" prop="state">
          <el-select
            v-model="searchParams.state"
            clearable
            placeholder="请选择方案状态"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in leasingSchemeStateList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同模板名称" prop="templateId">
          <el-select
            v-model="searchParams.templateId"
            clearable
            filterable
            placeholder="请选择合同模板"
          >
            <el-option
              v-for="item in templateList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="方案类型" prop="orderType">
          <el-select
            v-model="searchParams.orderType"
            clearable
            placeholder="请选择方案类型"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in orderTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否关联商品" prop="relProduct">
          <el-select
            v-model="searchParams.relProduct"
            clearable
            placeholder="请选择"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              class="whole_contract_btn"
              @click="searchHandle"
              :loading="oLoading.search"
            >
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="whole_contract_btn" @click="goReset">重置</el-button>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <div class="operation-box" v-if="judgePermission('for_rent_config_ren_plan_create')">
      <el-dropdown>
        <el-button v-if="judgePermission('for_rent_config_ren_plan_create')" type="primary">
          新建方案<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <el-button type="text" @click="goAddPage(PLAN_TYPE.PERSON)">个人租赁方案</el-button>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-button type="text" @click="goAddPage(PLAN_TYPE.ENTER)">企业租赁方案</el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <QS-common-table ref="tableComponent"
      :data="tableData"
      :columns="tableColumns"
      :pagination="pagination"
      @change="paginationChange"
    >
    </QS-common-table>

    <!-- 批量上架商品抽屉 -->
    <BatchDrawer ref="batchDrawerRef" @refresh="getList" />
  </div>
</template>
<script>
import configData, { STATE_ENUM, TYPE_ENUM, DIALOG_CONFIG } from './config'
import BatchDrawer from '@/pages/shop/commodity/batchDrawer/index.vue'
import SelectOption from '@/store/dict/selectOptionDict'
// eslint-disable-next-line import/no-cycle
import { contractTmpList } from '@/api/domain/carsService'
import {
  getLeasingSchemeConfigList,
  updateLeasingSchemeConfig,
} from '@/api/domain/cars'
import { disableRentVerification } from '@/api/domain/orders'
import { PLAN_TYPE } from '../const'
import { quick } from '@/utils/ba'
import { trackClick } from '@/utils/trackReport'

export default {
  components: {
    BatchDrawer,
  },
  data() {
    const { tableColumns } = configData.call(this)
    return {
      PLAN_TYPE,
      tableColumns,
      loading: false,
      oLoading: {
        search: false,
      },
      dialogWrap: {
        id: '',
        type: -1,
        title: '提示',
        orderType: '',
        contentTxt: '',
        sureBtnText: '',
      },
      tableData: [],
      templateList: [], // 合同模版列表
      pagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      searchParams: {
        id: '',
        name: '',
        state: '',
        orderType: '',
        templateId: '',
        adcode: '',
        brandSeriesModel: {},
        relProduct: null, // 是否关联商品
      },
    }
  },
  computed: {
    leasingSchemeStateList() {
      return this.dictParseList(SelectOption.leasingSchemeState)
    },
    orderTypeList() {
      return this.dictParseList(SelectOption.leaseOrderTypeList)
    },
    cityList() {
      return this.$store.getters.allCities
    },
  },
  created() {
    this.initQueryValue()
  },
  mounted() {
    this.getList()
    // 请求合同模版列表
    this.loadTemplateList()
  },
  methods: {
    initQueryValue() {
      Object.keys(this.$route.query).forEach((key) => {
        let _val = this.$route.query[key]
        if (
          [
            'modelId',
            'templateId',
            'orderType',
            'state',
          ].includes(key)
        ) {
          _val = Number(_val)
        }
        if (this.$route.query[key] && Object.prototype.hasOwnProperty.call(this.searchParams, key)) {
          this.searchParams[key] = _val
        }
      })
      const { pageSize, pageNum } = this.$route.query
      this.pagination = {
        ...this.pagination,
        pageSize: pageSize ? Number(pageSize) : 10,
        pageNum: pageNum ? Number(pageNum) : 1,
      }
    },
    // 合同模版列表
    async loadTemplateList() {
      const { code, data } = await contractTmpList({
        pageNum: 1,
        pageSize: 99999,
      })
      if (code === 1) {
        this.templateList = data?.items || []
        const templateId = this.$route?.query?.templateId
        if (templateId) {
          this.searchParams.templateId = Number(templateId)
          this.searchHandle()
        }
      }
    },
    // 重置
    goReset() {
      this.pagination.pageNum = 1
      // 使表单内容重新赋值为空字符串
      this.$refs.from_params.resetFields()
      this.$refs.carBrandSeriesModelRef.reset()
      this.searchParams = {
        id: '',
        name: '',
        state: '',
        orderType: '',
        templateId: '',
        adcode: '',
        brandSeriesModel: {},
      }
      this.$router.replace({
        path: this.$route.path,
      })
      this.searchHandle()
    },

    // 搜索事件
    searchHandle() {
      // 处理线上问题 20231024 查询问题
      this.pagination.pageNum = 1
      this.getList()
    },

    // 获取列表
    getList() {
      this.oLoading.search = true
      const { brandSeriesModel } = this.searchParams
      const params = {
        ...this.searchParams,
        brandId: brandSeriesModel.brandId,
        seriesId: brandSeriesModel.seriesId,
        modelId: brandSeriesModel.modelId,
      }
      delete params.brandSeriesModel
      getLeasingSchemeConfigList({
        ...params,
        ...this.pagination,
      }).then(({ code, data }) => {
        if (code === 1) {
          this.pagination.total = data.totalNum
          this.tableData = data.items || []
        } else {
          this.pagination.total = 0
          this.tableData = []
        }
      }).catch(() => {
        this.pagination.total = 0
        this.tableData = []
      }).finally(() => {
        this.oLoading.search = false
      })
    },
    paginationChange(payload) {
      const { pagination } = payload
      this.pagination.pageNum = pagination.pageNum
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    // eslint-disable-next-line vue/no-unused-properties
    async clickHandle(row, { type }) {
      this.dialogWrap.id = row.id
      this.dialogWrap.type = type
      this.dialogWrap.orderType = row.orderType

      if (type === TYPE_ENUM.ADDOREDIT && row.state === STATE_ENUM.ABLE) {
        this.loading = true
        const [err, res] = await this.$to(disableRentVerification({ id: row.id }))
        this.loading = false
        if (err || res?.code !== 1 || !res?.data) return
      }

      if (type === TYPE_ENUM.ADDOREDIT) {
        this.dialogWrap = { ...this.dialogWrap, ...DIALOG_CONFIG[row.state] }
      }

      this.$confirm(`${this.dialogWrap.contentTxt}【${row.name}】`, this.dialogWrap.title, {
        confirmButtonText: this.dialogWrap.sureBtnText,
        cancelButtonText: '取消',
      }).then(() => {
        this.submitHandle()
      }).catch(() => null)
    },

    // 去详情页
    // eslint-disable-next-line vue/no-unused-properties
    goDetail(row) {
      if (!this.judgePermission('for_rent_config_ren_plan_detail')) {
        return this.$message.error('暂无权限，请联系管理员开通')
      }
      this.$router.push({
        path: '/car_to_lease/leaseScheme/detail',
        query: {
          id: row.id,
          orderType: row.orderType,
        },
      })
    },

    // 提交事件
    submitHandle() {
      // 上下架
      if (this.dialogWrap.type === TYPE_ENUM.ADDOREDIT) {
        const { state } = this.tableData.filter(
          (item) => item.id === this.dialogWrap.id,
        )[0]
        this.updateHandle(!state ? 1 : 0)
      }
    },

    // 上下架事件
    updateHandle(state) {
      const jumpUrl = this.judgeFn()
      this.loading = true
      updateLeasingSchemeConfig({ id: this.dialogWrap.id, state }).then(({ code }) => {
        if (code === 1) {
          this.$message.success('修改成功')
          this.oLoading.search = true
          setTimeout(() => {
            this.oLoading.search = false
            this.getList()
          }, 3 * 1000)
        }
      }).catch((error) => {
        if (error.code === 22051) {
          this.$confirm(
            '当前有待确认订单，请将订单置为终态后再行下架',
            '方案下架提示',
            {
              showConfirmButton: Boolean(jumpUrl),
              confirmButtonText: '查看订单列表',
              cancelButtonText: '取消',
              type: 'warning',
            },
          ).then(() => {
            if (!jumpUrl) return
            this.$router.push({
              path: jumpUrl[this.dialogWrap.orderType].path,
              query: {
                ...jumpUrl[this.dialogWrap.orderType].query,
                planId: this.dialogWrap.id,
              },
            })
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          }).catch(() => {})
        } else if (error.code === 22052) {
          this.$confirm(
            '租赁方案无法上架，点击【去编辑】选择“启用”的合同模板后进行上架',
            '方案上架提示',
            {
              confirmButtonText: '去编辑',
              cancelButtonText: '取消',
              type: 'warning',
            },
          ).then(() => {
            this.goEditPage(this.dialogWrap)
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          }).catch(() => {})
        }
      }).finally(() => {
        this.loading = false
      })
    },
    judgeFn() {
      const { urlMap } = configData.call(this)
      let jumpUrl = false
      for (const key in urlMap) {
        if (this.judgePermission(key)) {
          jumpUrl = urlMap[key]
          return jumpUrl
        }
      }
      return jumpUrl
    },
    /**
     * @去新增页面
     * */
    goAddPage(type) {
      this.$router.push({
        path: '/car_to_lease/leaseScheme/add',
        query: {
          type,
        },
      })
    },
    // 去编辑页面
    goEditPage(rowData) {
      const { pageSize, pageNum } = this.pagination
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.searchParams, pageSize, pageNum },
      })
      this.$nextTick(() => {
        this.$router.push({
          path: '/car_to_lease/leaseScheme/edit',
          query: {
            id: rowData.id,
            type: rowData.orderType,
          },
        })
      })
    },
    // 复制 ./config/index.js有用
    // eslint-disable-next-line vue/no-unused-properties
    copy(rowData) {
      const { id, orderType } = rowData
      this.$router.push({
        path: '/car_to_lease/leaseScheme/copy',
        query: {
          id,
          type: orderType,
        },
      })
    },
    // 上架商品 - 打开批量上架抽屉（单个方案模式）./config/index.js有用
    // eslint-disable-next-line vue/no-unused-properties
    openBatchPublish(rowData) {
      quick('click', 'scheme_list_batch_publish_click')
      trackClick('scheme_list_batch_publish_click')
      this.$refs.batchDrawerRef?.open({
        mode: 'single',
        planId: rowData.id,
        source: 'leaseScheme',
      })
    },
    // 去商品列表页
    // eslint-disable-next-line vue/no-unused-properties
    goProductDetail(id) {
      this.$router.push({
        path: '/car_to_rent/commodity/list',
        query: {
          id,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.operation-box {
  margin-bottom: 16px;
}
::v-deep .el-table {
  .operate-btns {
    .cell {
      display: flex;
    }
  }
  .product-link {
    margin-left: 0;
  }
}
</style>
